import styled from "@emotion/styled";
import React from "react";
import { useSelector } from "react-redux";

import avantiicon from "../../assets/avantiicon.png";
import quitIcon from "../../assets/quitIcon.png";

const Header = (props) => {
  const { userData } = useSelector((state) => state.user);

  const rightComponent = () => {
    const isUserDataEmpty = !userData || Object.keys(userData).length === 0;

    return (
      <>
        {isUserDataEmpty ? (
          <div className="enter">
            <a href="/login">ENTRAR</a>
          </div>
        ) : (
          <div className="profile-container">
            {/* <a href={"/login"} className="user-link"> */}
            <div className="userData-container">
              <span className="loyalty-txt">{userData.LoyaltyCategory__c}</span>
              <span className="user-txt">{`${userData.FirstName} ${userData.LastName}`}</span>
            </div>
            {/* </a> */}

            <div className="quit-container">
              <a href={"/logout"} className="quit-container">
                <span className="quit-txt">Sair</span>
                <img src={quitIcon} alt="icone sair" className="quit-icon" />
              </a>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <Container className="content-simpletabs">
      <div className="content-tabs">
        <div className="avantiicon">
          <a href={"/"}>
            <img src={avantiicon} alt="avantiicon" />
          </a>
        </div>
        {rightComponent()}
      </div>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;

  .content-tabs {
    background-color: rgba(0, 59, 33, 1);
    height: 77px;
    flex: 1;
    display: flex;
    flex-direction: row;
    color: rgba(255, 255, 255, 1);
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    width: 100%;
    max-width: 100vw;
  }

  .avantiicon {
    margin-right: 16px !important;

    img {
      width: 118px;
      height: 36px;
    }
  }

  div.enter {
    display: flex;
    align-self: center !important;

    a {
      padding: 10px 20px;
      border-radius: 8px;
      background-color: rgba(218, 231, 83, 1) !important;
      color: rgba(0, 100, 55, 1);
      font-family: Roboto;
      font-weight: 700;
      font-size: 18px;
      line-height: 21.09px;
      letter-spacing: 0%;
    }
  }

  .profile-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 32px;
  }

  .userData-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .loyalty-txt {
      font-family: "Roboto";
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      color: #e7c394;
      text-transform: capitalize;
    }

    .user-txt {
      font-family: "Roboto";
      font-size: 16px;
      line-height: 18px;
      font-weight: 700;
      color: #ffffff;
      text-transform: uppercase;
    }
  }

  .quit-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;

    .quit-txt {
      font-family: "Roboto";
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      color: #ffffff;
      text-transform: capitalize;
      opacity: 0.5;
    }

    .quit-icon {
      width: 16px;
      height: 16px;
      opacity: 0.5;
    }
  }
`;
